import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { GroupPortalDataService } from '../services';
import { GlobalDomOpsService } from '@acepteam/globalspack';
import { first } from 'rxjs/operators';
import { DataService } from '../../core/services';

@Injectable({
  providedIn: 'root'
})
export class GroupPortalUIDataResolve implements Resolve<any> {

  constructor(private service: DataService, private globaldomops: GlobalDomOpsService) {}

  resolve(route: ActivatedRouteSnapshot) {    
    return this.service.GetUIData().pipe(first()); //take(1) // To make the observable complete after the first emission;
  }

}

